<form @submit.prevent="search" style="display: flex; flex-direction: row; gap: 1rem; flex-wrap: wrap;">
    <div style="flex: 1 1; display: flex; flex-direction: column; gap: .5rem; flex-basis: 16em">
        <label for="documentNumber">Document nummer</label>
        <InputText name="documentNumber" placeholder="Zoek trefwoord" autocomplete="off" v-model="documentNumber" />
    </div>
    <div v-if="enableCustomerReferenceFilter" style="flex: 1 1; display: flex; flex-direction: column; gap: .5rem; flex-basis: 16em">
        <label for="customerReference">Eigen referentie</label>
        <InputText name="customerReference" placeholder="Eigen referentie" autocomplete="off" v-model="customerReference" />
    </div>
    <div style="flex: 1 1; display: flex; flex-direction: row; gap: 1rem; flex-basis: 22em">
        <div style="flex: 1 1; display: flex; flex-direction: column; gap: .5rem;">
            <label for="date-from">van</label>
            <DatePicker show-icon placeholder="van" v-model="dateFrom" id="date-from" :max-date="dateFromMaxDate"/>
        </div>
        <div style="flex: 1 1; display: flex; flex-direction: column; gap: .5rem;">
            <label for="date-to">tot en met</label>
            <DatePicker show-icon placeholder="tot en met" v-model="dateTo" id="date-to" :min-date="dateToMinDate"/>
        </div>
    </div>
    <div v-if="enableServiceFilter" style="flex: 1 1; display: flex; flex-direction: column; gap: .5rem; flex-basis: 10em">
        <label for="service">Service</label>
        <Select :options="serviceOptions" option-label="label" option-value="value" placeholder="Service" id="service" name="service" v-model="service">
        </Select>
    </div>
    <div v-if="enableDocumentTypeFilter" style="flex: 1 1; display: flex; flex-direction: column; gap: .5rem; flex-basis: 15em">
        <label for="documentType">Type</label>
        <Select :options="documentTypeOptions" option-label="label" option-value="value" placeholder="Type" id="documentType" name="documentType" v-model="selectedDocumentType">
        </Select>
    </div>
</form>
